import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Company } from '../../models/company.model';
import { CompanyMockService } from '../../services/company-mock.service';

@Component({
  selector: 'bwc-company-detail',
  templateUrl: './company-detail.component.html',
  styleUrls: ['./company-detail.component.scss'],
})
export class CompanyDetailComponent implements OnInit {
  company: Company | undefined;
  allCompanies: Company[] = [];
  currentIndex = 0;
  isFollowing = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private companyService: CompanyMockService
  ) {}

  ngOnInit(): void {
    this.companyService.getCompanies().subscribe(companies => {
      this.allCompanies = companies;
      this.route.params.subscribe(params => {
        const id = Number(params['id']);
        this.currentIndex = this.allCompanies.findIndex(c => c.id === id);
        this.company = this.allCompanies[this.currentIndex] || this.allCompanies[0];
        this.isFollowing = this.companyService.getFollowedIds().includes(this.company?.id);
      });
    });
  }

  get canGoPrevious(): boolean { return this.currentIndex > 0; }
  get canGoNext(): boolean { return this.currentIndex < this.allCompanies.length - 1; }

  goPrevious(): void {
    if (this.canGoPrevious) {
      this.router.navigate(['/profile-check/companies', this.allCompanies[this.currentIndex - 1].id]);
    }
  }

  goNext(): void {
    if (this.canGoNext) {
      this.router.navigate(['/profile-check/companies', this.allCompanies[this.currentIndex + 1].id]);
    }
  }

  toggleFollow(): void {
    if (this.company) {
      this.isFollowing = this.companyService.toggleFollowCompany(this.company);
    }
  }

  goBack(): void {
    this.router.navigate(['/profile-check/companies/for-you']);
  }
}
